import type { RetryConfig } from "../types/retry.js";

export function getMaxAttempts(retry?: RetryConfig): number {
  return Math.max(1, retry?.attempts ?? 1);
}

export function shouldRetry(error: unknown, attempt: number, retry?: RetryConfig): boolean {
  if (!retry || attempt >= getMaxAttempts(retry)) return false;
  return retry.shouldRetry ? retry.shouldRetry(error) : true;
}

export function getRetryDelayMs(attempt: number, retry?: RetryConfig): number {
  if (!retry) return 0;
  const base = retry.delayMs ?? 1000;
  let delayMs: number;
  switch (retry.backoff ?? "fixed") {
    case "linear":
      delayMs = base * attempt;
      break;
    case "exponential":
      delayMs = base * 2 ** Math.max(0, attempt - 1);
      break;
    case "fixed":
    default:
      delayMs = base;
      break;
  }
  if (typeof retry.maxDelayMs === "number") delayMs = Math.min(delayMs, retry.maxDelayMs);
  return Math.max(0, Math.round(applyJitter(delayMs, retry.jitter)));
}

function applyJitter(delayMs: number, jitter: RetryConfig["jitter"]): number {
  if (!jitter) return delayMs;
  const ratio = jitter === true ? 0.2 : Math.max(0, Math.min(1, jitter));
  const variance = delayMs * ratio;
  const min = delayMs - variance;
  return min + Math.random() * variance * 2;
}
